module.exports = __webpack_public_path__ + "static/header-top-ae93bc9148a43b3d7941cf2010d5e542.svg";